import React from "react";

// Free OpenStreetMap embed, no API key or dependency. coords = [lat, lng].
export default function ProjectMap({ coords, title }) {
  const [lat, lng] = coords;
  const d = 0.35;
  const bbox = [lng - d, lat - d, lng + d, lat + d].join(",");
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat},${lng}`;
  return <iframe className="pg-map" title={`Map: ${title}`} src={src} loading="lazy" />;
}
